/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmPasswordResetRequest
 */
export interface ConfirmPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmPasswordResetRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmPasswordResetRequest
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmPasswordResetRequest
     */
    oobCode: string;
}

/**
 * Check if a given object implements the ConfirmPasswordResetRequest interface.
 */
// @ts-ignore
export function instanceOfConfirmPasswordResetRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "newPassword" in value;
    isInstance = isInstance && "oobCode" in value;

    return isInstance;
}

// @ts-ignore
export function ConfirmPasswordResetRequestFromJSON(json: any): ConfirmPasswordResetRequest {
    return ConfirmPasswordResetRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function ConfirmPasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmPasswordResetRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'newPassword': json['new_password'],
        'oobCode': json['oob_code'],
    };
}

// @ts-ignore
export function ConfirmPasswordResetRequestToJSON(value?: ConfirmPasswordResetRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'new_password': value.newPassword,
        'oob_code': value.oobCode,
    };
}

